@if (isListDefined) {
  <div class="self-service-selection">
    <label>Self service list admin for EHS Users</label>
    <mat-radio-group [(ngModel)]="list.CanAdd" [disabled]="updatingListSelfServiceEnabled" (change)="onListCanAddChanged($event)">
      <mat-radio-button [value]="true">Enable</mat-radio-button>
      <mat-radio-button [value]="false">Disable</mat-radio-button>
    </mat-radio-group>
  </div>
}
@if (isListDefined && listItems) {
  <mat-tab-group>
    <mat-tab label="List Items" id="list-editor-list-items">
      @if (areListItems()) {
        <div class="select-all">
          <mat-checkbox class="action-label" (change)="setAll($event.checked)" [checked]="selectAll">Select All</mat-checkbox>
          <a mat-raised-button color="warn" [disabled]="!isAtLeastOneSelected()" (click)="deleteItems()">Delete {{ getSelectedListItemNumber() }} Items</a>
        </div>
      }
      <mat-list [ngClass]="{'embed': embedded}">
        @for (item of listItems; track item) {
          <mat-list-item>
            <span class="item-select">
              <mat-checkbox [(ngModel)]="item.Selected" (ngModelChange)="updateSelectAll()" id="list-editor-select-list-item-{{item.Value}}"></mat-checkbox>
            </span>
            <span class="text" id="list-editor-list-item-{{item.Value}}">
              {{item.Text}}
              @if (item.AddedByFeed) {
                <span class="added-by-feed">&nbsp;&nbsp;(Added by Feed)</span>
              }
              @if (item.Deactivated) {
                <span class="added-by-feed">&nbsp;&nbsp;(Deactivated)</span>
              }
            </span>
            <span class="delete-button">
              @if (deletingItem !== item) {
                <button mat-button
                  (click)="setDeleting(item)"
                  id="list-editor-delete-list-item-{{item.Value}}">
                  <mat-icon>delete</mat-icon>
                </button>
              }
              @if (deletingItem === item) {
                <span title="Are you sure you want to delete this item? It will be hidden from the whole system and records that reference it may become unstable.">
                  Sure? &nbsp;
                  <button mat-icon-button color="warn" (click)="deleteItem(item)" title="Delete it" id="list-editor-delete-list-item-confirm-{{item.Value}}"><mat-icon>delete</mat-icon></button>
                  <button mat-icon-button (click)="setDeleting(null)" title="Cancel" id="list-editor-delete-list-item-cancel-{{item.Value}}"><mat-icon>close</mat-icon></button>
                </span>
              }
            </span>
          </mat-list-item>
        }
      </mat-list>
      <div>
        <div class="error">{{listItemErrorString}}</div>
        <span>
          <mat-form-field>
            <input matInput placeholder="New Item" [(ngModel)]="newItemString" id="list-editor-add-list-item-text" />
          </mat-form-field>
          <button mat-icon-button (click)="newItem()" id="list-editor-add-list-item">
            <mat-icon>add</mat-icon>
          </button>
        </span>
      </div>
    </mat-tab>
    <mat-tab label="List Attributes" id="list-editor-list-attributes">
      <mat-list [ngClass]="{'embed': embedded}">
        @for (attribute of listAttributeDefinitions; track attribute) {
          <mat-list-item>
            <span class="text" id="list-editor-attribute-name-{{attribute.Name}}">
              {{attribute.Label}}
            </span>
          </mat-list-item>
        }
      </mat-list>
      <div class="add-attribute-form">
        @if (listAttributeDefinitionErrorString) {
          <div class="error">{{listAttributeDefinitionErrorString}}</div>
        }
        <div>
          <mat-form-field>
            <input matInput placeholder="New List Attribute" [(ngModel)]="newListAttributeName" id="list-editor-new-attribute-text" />
          </mat-form-field>
        </div>
        <div>
          <mat-select [(value)]="controlType" id="list-editor-attribute-type-dropdown">
            <mat-option value="Text" id="list-editor-attribute-type-dropdown-text">Text</mat-option>
            <mat-option value="Number" id="list-editor-attribute-type-dropdown-number">Number</mat-option>
            <mat-option value="Bool" id="list-editor-attribute-type-dropdown-bool">Boolean</mat-option>
          </mat-select>
        </div>
        <button mat-raised-button color="accent" (click)="addListAttributeDefinition()" id="list-editor-attribute-add">Add</button>
      </div>
    </mat-tab>
  </mat-tab-group>
}
@if (!listItems) {
  <div class="loading-items">
    <mat-spinner style="margin: 0 auto;"></mat-spinner>
  </div>
}